import { onCLS, onFCP, onINP, onLCP, onTTFB, Metric } from 'web-vitals'
import { getAppInsights, hasAnalyticsConsent } from './appInsights'

function sendToAppInsights(metric: Metric) {
  if (!hasAnalyticsConsent()) return

  const appInsights = getAppInsights()
  if (!appInsights) return

  appInsights.trackMetric({
    name: `web_vitals.${metric.name}`,
    average: metric.value,
    sampleCount: 1,
    properties: {
      id: metric.id,
      navigationType: metric.navigationType || 'unknown',
      rating: metric.rating, // 'good', 'needs-improvement', 'poor'
      page: typeof window !== 'undefined' ? window.location.pathname : '',
    },
  })

  // Also track as custom event for easier querying
  appInsights.trackEvent({
    name: 'WebVital',
    properties: {
      metric: metric.name,
      value: String(metric.value),
      rating: metric.rating,
      page: typeof window !== 'undefined' ? window.location.pathname : '',
    },
  })
}

export function initWebVitals() {
  if (typeof window === 'undefined') return

  // Core Web Vitals
  onCLS(sendToAppInsights) // Cumulative Layout Shift
  onFCP(sendToAppInsights) // First Contentful Paint
  onLCP(sendToAppInsights) // Largest Contentful Paint
  onTTFB(sendToAppInsights) // Time to First Byte

  // Interaction metrics
  onINP(sendToAppInsights) // Interaction to Next Paint
}
